import React, { useReducer } from "react";
import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import eye from "../img/eye.png";
import { supabaseAnon } from "../db";

const ChangePassword = ({ setPage }) => {
  // Initialising useNavigate + useRef
  const navigate = useNavigate();
  const currentPasswordRef = useRef(null);
  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  const [currentPassword, setCurrentPassword] = useState("");
  const [changePassword, setChangePassword] = useState("");
  const [confirmChangePassword, setConfirmChangePassword] = useState("");
  const [isPasswordHidden, setIsPasswordHidden] = useState(false);
  const [invalidFields, setInvalidFields] = useState({
    currentPassword: false,
    password: false,
    confirmPassword: false,
  });

  // Returns if the password and confirm password inputs are equal
  const arePasswordsEqual = () => {
    if (changePassword === confirmChangePassword) return true;
  };

  // Uses same endpoint used to log in to check if the password is correct
  const isCurrentPasswordEnteredCorrect = async () => {
    // Get the current user from Supabase auth; prefer `user.email`, fallback to `user_metadata.email`
    const { data: { user } = {} } = await supabaseAnon.auth.getUser();
    const email = user?.email ?? user?.user_metadata?.email;

    // Check if current password matches original (encode values for safety)
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/users/login?email=${encodeURIComponent(
        email
      )}&password=${encodeURIComponent(currentPassword)}`
    );
    const data = await response.json();

    if (data.message.login === true) {
      return email;
    } else {
      return false;
    }
  };

  // Entry function called when submit button is pressed
  const handleClick = async () => {
    // Resetting all of the inputs
    setInvalidFields({
      password: false,
      confirmPassword: false,
      currentPassword: false,
    });

    const isPasswordCorrect = await isCurrentPasswordEnteredCorrect();

    if (isPasswordCorrect !== false) {
      // Accessing the result of the validateinputs function
      const areInputsValid = arePasswordsEqual();
      // If true isnt returned (there is an error)
      if (areInputsValid !== true) {
        // Alerting the user of the error that has occured
        alert(areInputsValid);
        // If it equals passwords do not match
        if (areInputsValid === "Passwords do not match") {
          setInvalidFields((prev) => ({
            ...prev,
            password: true,
            confirmPassword: true,
          }));
          return;
        }
      } else {
        // All inputs are valid -> redirect to correct page depending on what plan was selected
        const passwordChangeRequest = await handleChangePasswordRequest();
        console.log(passwordChangeRequest);

        if (passwordChangeRequest.message === "Password Successfully Updated") {
          setPage("login");
          navigate("/login");
        } else {
          setInvalidFields((prev) => ({
            ...prev,
            password: true,
            confirmPassword: true,
            currentPassword: true,
          }));
          return;
        }
      }
    } else {
      setInvalidFields((prev) => ({ ...prev, currentPassword: true }));
      return;
    }
  };

  const handleChangePasswordRequest = async () => {
    // Make request with anon key
    const { error } = await supabaseAnon.auth.updateUser({
      password: changePassword,
    });

    if (!error) {
      return {
        message: "Password Successfully Updated",
      };
    } else {
      return {
        message: `Password update failed ${error.message}`,
      };
    }
  };

  return (
    <div className="change-password-container">
      <h1>Change Password Page</h1>

      <div className="current-password">
        <input
          className={invalidFields.password ? "input-error" : "input"}
          type={isPasswordHidden ? "text" : "password"}
          ref={currentPasswordRef}
          name="password-change"
          placeholder="Current Password..."
          value={currentPassword}
          required
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        <button
          className="hide-button"
          onClick={(e) => {
            e.preventDefault();
            setIsPasswordHidden((prev) => !prev);
          }}
        >
          <img src={eye} />
        </button>
      </div>
      <div className="password-input">
        <input
          className={invalidFields.password ? "input-error" : "input"}
          type={isPasswordHidden ? "text" : "password"}
          ref={passwordRef}
          name="password-change"
          placeholder="New Password..."
          value={changePassword}
          required
          onChange={(e) => setChangePassword(e.target.value)}
        />
        <button
          className="hide-button"
          onClick={(e) => {
            e.preventDefault();
            setIsPasswordHidden((prev) => !prev);
          }}
        >
          <img src={eye} />
        </button>
      </div>
      <div className="confirm-password">
        <input
          className={invalidFields.confirmPassword ? "input-error" : "input"}
          type={isPasswordHidden ? "text" : "password"}
          ref={confirmPasswordRef}
          name="confirm-password-change"
          placeholder="Confirm New Password..."
          value={confirmChangePassword}
          required
          onChange={(e) => setConfirmChangePassword(e.target.value)}
        />
        <button
          className="hide-button"
          onClick={(e) => {
            e.preventDefault();
            setIsPasswordHidden((prev) => !prev);
          }}
        >
          <img src={eye} />
        </button>
      </div>

      <button onClick={handleClick}>Change Password</button>
    </div>
  );
};

export default ChangePassword;
